<template>
  <section>
    <span class="name" :class="{ name: !parent, parentName: parent }">{{
      name
    }}</span>
    <span
      class="separator"
      :class="{ separator: !parent, noSeparator: parent }"
    >
      :
    </span>
    <span class="value" :class="{ value: !parent, noValue: parent }">{{
      value
    }}</span>
  </section>
</template>

<script>
export default {
  name: "Entries",
  props: ["name", "value", "parent"],
};
</script>

<style scoped>
section {
  margin-top: 1rem;
}
.name {
  background-color: #6c88c9;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
}
.separator {
  background-color: #b6c4e4;
  padding: 1px 1px 1px 0px;
  border-radius: 0px;
  margin-left: 5px;
  margin-right: 5px;
  font-weight: bold;
  border-radius: 30%;
}
.value {
  background-color: white;
  color: #385879;
  padding: 4px 8px;
  border-radius: 4px;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
}

.parentName {
  background-color: #6c88c9;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  border: solid 3px #5068a5;
}

.noSeparator {
  display: none;
}

.noValue {
  display: none;
}
</style>